import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AddressConfig } from 'src/app/shared/components/address/address-config.model';
import { AddressComponent } from 'src/app/shared/components/address/address.component';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { Message } from 'src/app/shared/constants/message';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { CustomValidator } from 'src/app/shared/validators/custom-validator';
import { SharedFormService } from 'src/app/shared/services/SharedFormService.service';
import * as _ from 'underscore';

@Component({
    selector: 'app-direct-entity-form',
    templateUrl: './direct-entity-form.component.html',
    styleUrls: ['./direct-entity-form.component.less'],
    standalone: false
})
export class DirectEntityFormComponent implements OnInit {

  constructor(private logger:NGXLogger,private formBuilder:FormBuilder,
              private utilityService:UtilityService,private router:Router,
              private service:DataService,private activatedRoute:ActivatedRoute,
              private permissionService:PermissionService, private dailog:MatDialog,
              private sharedFormService:SharedFormService) {
                this.activatedRoute.params.subscribe((params:Params)=>{
                  if (params['data']){
                    this.shippingBillData = JSON?.parse(params['data']);
                  }
                });
               }
  shippingBillData:any;
  directEntityForm:FormGroup;
  @ViewChild(AddressComponent) addressComponent;
  addressConfig=new AddressConfig(true,true,true,false,true,false,false,true,false);
  editPermission:boolean=false;
  addPermission:boolean=false;
  isEditedData:boolean=false;

  ngOnInit(): void {
    this.loadSharedShippingBillData();
    this.logger.info("Bill Data: ",this.shippingBillData);
    this.getAllPermissions();
    this.initializeForm();
    this.fetchParam();
  }

  private fetchParam(){
    this.activatedRoute.params.subscribe(
      (param:Params) => {
        if(+param['id']){
          this.id.setValue(+param['id']);
          this.getDirectEntityById();
        }
    });
  }

  private initializeForm(){
    this.directEntityForm=this.formBuilder.group({
      id:[null],
      parentId:[],
      code:[null,[Validators.maxLength(6)]],
      name:[null,[Validators.required,CustomValidator.whiteSpaceValidator]],
      address:this.utilityService.getAddressForm(),
    })
  }

  openDailog(message?:string)
  {
    const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
        data:message,
        maxWidth:"300px",
        maxHeight:"150px"
      });

    dailogRef.afterClosed().subscribe(dailogResult => {
        if(dailogResult===false){
          return;
        }
        else {
          if(!this.isEditedData) {
            if(this.shippingBillData?.isCfs){
              this.sharedFormService.setFormState('CFS',this.shippingBillData);
              this.router.navigate([APP_ROUTES.SHIPPING_BILL+"/cfs/add/"],{skipLocationChange: true})
            }else if(this.shippingBillData?.isHub){
              this.sharedFormService.setFormState('HUB',this.shippingBillData);
              this.router.navigate([APP_ROUTES.SHIPPING_BILL+"/hub/add/"],{skipLocationChange: true})
            }else if(this.shippingBillData?.isCsr){
              this.sharedFormService.setFormState('CSR',this.shippingBillData);
              this.shippingBillData?.id
                ? this.router.navigate([APP_ROUTES.CUSTOMER_SERVICE_REQUIREMENT+'/edit/'+this.shippingBillData.id],{skipLocationChange: true})
                : this.router.navigate([APP_ROUTES.CUSTOMER_SERVICE_REQUIREMENT+'/add'],{skipLocationChange: true});
            }else{
              this.router.navigate([APP_ROUTES.DIRECT_ENTITY_LIST]);
            }
          }
          else {
            this.saveDirectEntity();
          }
        }
    })
  }

  onSave(){
     this.address=this.addressComponent.address.value;
     this.directEntityForm.markAllAsTouched();
     this.addressComponent.address.markAllAsTouched();
     this.logger.info('Direct Entity Value Before Valid',this.directEntityForm.value);
     if(this.directEntityForm.valid && this.addressComponent.address.valid && (this.addressComponent.address.dirty || this.directEntityForm.dirty)){
        this.isEditedData=true;
        if(this.id.value){
            this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT);
        }
        else {
          this.openDailog(Message.SAVE_OPEN_DAILOG);
        } 
  }
}

  private saveDirectEntity(){
    let method = (this.id.value) ? 'put' : 'post';
    let message=(this.id.value) ? 'updated' : 'saved';
    this.logger.info("Bill Data",this.shippingBillData);
    this.service[method](Api.DIRECT_ENTITY, this.directEntityForm.value).subscribe(res => {
      this.utilityService.notifier(`Direct Entity ${message} successfully`, 'success');

      if(this.shippingBillData?.isCfs){
        if(this.shippingBillData.isConsignee){
          this.shippingBillData.consigneeId = res.id;
          this.shippingBillData.consigneeAddress = res.address.address;
          this.logger.debug("checking the consignee Detail in ShippingbillData", this.shippingBillData);
        }else{
          this.shippingBillData.shipperId = res.id;
          this.shippingBillData.shipperAddress = res.address.address;
          this.logger.debug("checking the shipper Detail in ShippingbillData", this.shippingBillData);
        }
        
        this.sharedFormService.setFormState('CFS', this.shippingBillData);
        this.shippingBillData?.id
          ? this.router.navigate([APP_ROUTES.SHIPPING_BILL + "/cfs/edit/", this.shippingBillData.id], { skipLocationChange: true })
          : this.router.navigate([APP_ROUTES.SHIPPING_BILL + "/cfs/add"], { skipLocationChange: true });
          this.logger.debug("Updated Shipping bill Data for CFS", this.shippingBillData);

      } else if(this.shippingBillData?.isHub){
        if(this.shippingBillData.isConsignee){
          this.shippingBillData.consigneeId = res.id;
          this.shippingBillData.consigneeAddress = res.address.address;
        }else{
          this.shippingBillData.shipperId = res.id;
          this.shippingBillData.shipperAddress = res.address.address;
        }

        this.sharedFormService.setFormState('HUB', this.shippingBillData);
        this.shippingBillData?.id
          ? this.router.navigate([APP_ROUTES.SHIPPING_BILL + "/hub/edit/", this.shippingBillData.id], { skipLocationChange: true })
          : this.router.navigate([APP_ROUTES.SHIPPING_BILL + "/hub/add"], { skipLocationChange: true });
          this.logger.debug("Updated Shipping bill Data for HUB", this.shippingBillData);

      } else if(this.shippingBillData?.isCsr){
        if(this.shippingBillData.isConsignee){
          this.shippingBillData.consigneeId = res.id;
        }else{
          this.shippingBillData.shipperId = res.id;
        }
        this.sharedFormService.setFormState('CSR', this.shippingBillData);
        this.shippingBillData?.id
          ? this.router.navigate([APP_ROUTES.CUSTOMER_SERVICE_REQUIREMENT+'/edit/'+this.shippingBillData.id],{skipLocationChange: true})
          : this.router.navigate([APP_ROUTES.CUSTOMER_SERVICE_REQUIREMENT+'/add'],{skipLocationChange: true});
      } else{
        this.router.navigate([APP_ROUTES.DIRECT_ENTITY_LIST]);
      }
    });
  }

  onCancel(){
    if(this.directEntityForm.dirty && this.directEntityForm.markAsTouched)
    {
      this.isEditedData=false;
      this.id.value?this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT):this.openDailog(Message.CANCEL_OPEN_DAILOG);
    }else if(this.shippingBillData?.isCfs){
      this.sharedFormService.setFormState('CFS',this.shippingBillData);
      this.shippingBillData?.id ?
      this.router.navigate([APP_ROUTES.SHIPPING_BILL+"/cfs/edit/"+this.shippingBillData.id],{skipLocationChange: true}) :
      this.router.navigate([APP_ROUTES.SHIPPING_BILL+"/cfs/add"],{skipLocationChange: true})
    }else if(this.shippingBillData?.isHub){
      this.sharedFormService.setFormState('HUB',this.shippingBillData);
      this.shippingBillData?.id ?
        this.router.navigate([APP_ROUTES.SHIPPING_BILL+"/hub/edit/"+this.shippingBillData.id],{skipLocationChange: true}):
        this.router.navigate([APP_ROUTES.SHIPPING_BILL+"/hub/add"],{skipLocationChange: true})
    }else if(this.shippingBillData?.isCsr){
      this.sharedFormService.setFormState('CSR',this.shippingBillData);
      this.shippingBillData?.id
        ? this.router.navigate([APP_ROUTES.CUSTOMER_SERVICE_REQUIREMENT+'/edit/'+this.shippingBillData.id],{skipLocationChange: true})
        : this.router.navigate([APP_ROUTES.CUSTOMER_SERVICE_REQUIREMENT+'/add'],{skipLocationChange: true});
    }else{
      this.router.navigate([APP_ROUTES.DIRECT_ENTITY_LIST]);
    }
  }

  private getDirectEntityById(){
    if(this.id.value){
    this.service.get(Api.DIRECT_ENTITY+'/'+this.id.value).subscribe(res => {
      if(res){
          this.logger.info('Direct Entity By Id Res',res);
          this.addressComponent.address.patchValue({...res.address,
          landMarkSet:res.address.landMarkSet || []    
        });
        this.directEntityForm.patchValue({...res,
          address: {...res.address,
            landMarkSet:res.address?.landMarkSet || []    
          }
        });
      }
    })
  }
  }

  private getAllPermissions(){
    let permissionCodes=[PermissionKey.DIRECT_ENTITY_MODULE_ADD_PERMISSION,PermissionKey.DIRECT_ENTITY_MODULE_EDIT_PERMISSION];
    let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.DIRECT_ENTITY);
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.DIRECT_ENTITY_MODULE_ADD_PERMISSION})?.show?true:false;
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.DIRECT_ENTITY_MODULE_EDIT_PERMISSION})?.show?true:false;
  }

  private loadSharedShippingBillData(): void {
  const savedData = this.sharedFormService.getFormState('CFS') || this.sharedFormService.getFormState('HUB') || this.sharedFormService.getFormState('CSR');
  if (savedData) {
    this.shippingBillData = { ...this.shippingBillData, ...savedData };
    this.logger.debug("checking the shipping bill and merged data ",this.shippingBillData);
  }
}


  get id(){ return this.directEntityForm.get('id'); }
  get name(){ return this.directEntityForm.get('name'); }
  get code(){ return this.directEntityForm.get('code'); }
  set address(address){ this.directEntityForm.get('address').patchValue(address); }
}
